<div class="overlay" [attr.data-status]="status">
  @switch (status) {
    @case ("requesting-permissions") {
      <div class="status-body">
        <div class="spinner"></div>
        <p class="status-text">
          Allow camera &amp; microphone access to continue
        </p>
      </div>
    }
    @case ("permission-denied") {
      <div class="status-body">
        <div class="icon-badge denied">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>
        <h3 class="status-title">Camera access denied</h3>
        <p class="status-text">
          Allow camera and microphone in your browser settings, then refresh the
          page.
        </p>
      </div>
    }
    @case ("waiting") {
      <div class="status-body">
        <div class="pulse-rings"><span></span><span></span><span></span></div>
        <p class="status-text">Finding someone to connect with&hellip;</p>
        <button class="cancel-btn" type="button" (click)="cancel.emit()">
          Cancel
        </button>
      </div>
    }
    @case ("connecting") {
      <div class="status-body">
        <div class="spinner"></div>
        <p class="status-text">Connecting&hellip;</p>
        <button class="cancel-btn" type="button" (click)="cancel.emit()">
          Cancel
        </button>
      </div>
    }
    @case ("peer-skipped") {
      <div class="status-body">
        <p class="status-text">
          Partner skipped &mdash; finding someone new&hellip;
        </p>
      </div>
    }
    @case ("peer-left") {
      <div class="status-body">
        <p class="status-text">
          Partner left &mdash; finding someone new&hellip;
        </p>
      </div>
    }
  }
</div>
